import SliderBottomImage from "../../assets/img/content/hero-img.png";
import { MouseEvent } from "react";
import { useHistory } from "react-router";
import "./SliderComponent.css";
import subheadingData from "../../assets/subheadingData.json";

const SliderComponent = () => {
    const history = useHistory();
    const register = (event: MouseEvent, registerType: string) => {
        event.preventDefault();
        history.push("/register/" + registerType);
    }
    return (
        <section className="bg-light md index-slider">
            <div className="container-body">
                <div className="row">
                    <div className="col-lg-7">
                        <div className="padding-top-10per btn-text-center">
                            <h2 className="index-slider-tech-inter">Technical Interviews</h2>
                            <h2 className="index-slider-ondemand">On Demand</h2>
                            <div className="subheading-carousel fx-crossfade">
                                {subheadingData.map((item, index) => (
                                    <p key={index}>{item.text}</p>
                                ))}
                            </div>
                            <div >
                                <div className="row mt-n4" >
                                    <div className="col-sm-4 mt-4">
                                        <div className="counter-box">
                                            <h4 className="countup text-white d-block">5,80,000</h4>
                                            <p className=" font-weight-600 text-white m-0  index-slider-completed-interviews">Completed interviews</p>
                                        </div>
                                    </div>
                                    <div className="col-sm-4 mt-4">
                                        <div className="counter-box">
                                            <h4 className="countup text-white d-block">370</h4>
                                            <p className=" font-weight-600 text-white m-0 index-slider-companies-registered">Companies registered</p>
                                        </div>
                                    </div>
                                    <div className="col-sm-4 mt-4">
                                        <div className="counter-box">
                                            <h4 className="countup text-white d-block">3,200</h4>
                                            <p className=" font-weight-600 text-white m-0 index-slider-interviewers">Interviewers</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <a className="butn primary  mt-4 yellow-border" onClick={(e) => { register(e, "Company"); }}><span>Register as  Employer</span></a>
                            &ensp;<a className="butn white  mt-4" onClick={(e) => { register(e, "Candidate"); }}><span>Register as  Candidate</span></a>
                        </div>
                    </div>
                    <div className="col-lg-5 mb-4 mb-lg-0">
                        <img src={SliderBottomImage} alt="..." className="hero-pic"></img>
                    </div>
                </div>
            </div>
        </section>
    );
};
export default SliderComponent;